import { instanceToPlain, plainToInstance } from 'class-transformer';
import { useNavigate, useParams } from 'react-router-dom';
import StandardForm from 'components/shared/StandardForm';
import FormStepper from 'components/form-stepper/FormStepper';
import { useEdit } from 'hooks/useEdit';
import { ActionCloseReason } from 'constants/CloseReasonTypes';
import { TypeMode } from 'constants/TypeMode';
import MainCard from 'components/MainCard';

// eslint-disable-next-line react/prop-types, no-unused-vars
const EditDataForm = ({
    navigateTo,
    slice,
    service,
    pageTitle,
    config,
    entity,
}) => {
    const navigate = useNavigate();

    const defaultValue = {
        original_message:
            '09.10.2024 at 09:50 by the aerial reconnaissance group MIB 6 Mech. Inf. Bde. on the territory of the RF in the area of the north-west outskirts of the settlement XXXXXXXXXX 2 military personnel were detected moving towards DKU, to the wooded area. Distance from DK up to 200 m. Coordinates: MGRS: 36U YA 06376 91531. Fire damage is being inflicted by mortar, AGS and FPV. Broadcast: MIB 6 Mech. Inf. Bde., stream "Kuzya".',
        id: 20,
        external_id: 'c775191b-fe60-41a4-baaa-2c6e97046775',
        source: 'whatsapp',
        type: 'OBSERVATION',
        started_at: '09.10.2024 09:50',
        finished_at: null,
        created_at: '2024-10-24T21:20:05.280566',
        updated_at: '2024-10-24T21:20:05.280567',
        unit: 'MIB 987 Mech. Inf. Bde',
        local_unit: null,
        weapon_type: null,
        mgrs_coordinates: ['36U YA 06376 91531'],
        coordinates: [[50.43946163646473, 35.90646058806631]],
        direction: 'to DKU',
        azimuth: null,
        target_type: 'personnel',
        target_quantity: 2,
        result: 'Fire damage is being inflicted by mortar',
        status: false,
        link: 'https://xsltdev.ru/favicon.ico',
    };
    const status = 'success';

    const handleOnClose = action => {
        navigate(navigateTo, {
            state: action === ActionCloseReason.Submit ? 'refresh' : null,
        });
    };

    const handleOnSubmit = async (
        data,
        successCallback,
        errorCallback,
        requestCallback,
    ) => {
        const postData = plainToInstance(entity, data);
        try {
            // eslint-disable-next-line react/prop-types
            const response = await service.update({ data: postData });
            if (response?.data.hasOwnProperty('requestId')) {
                const jobTaskId = response?.data.requestId;
                if (!jobTaskId && response?.hasOwnProperty('requestId'))
                    throw new Error('Data not saved');
                // throw new Error("Data not saved");
                requestCallback(jobTaskId);
            } else {
                // successCallback("Data saved");
                successCallback('Data saved');
            }
        } catch (err) {
            // errorCallback(err, "An error occurred");
            errorCallback(err, 'An error occurred');
        }
    };

    return (
        <StandardForm
            title={pageTitle}
            mode={TypeMode.Edit}
            status={status}
            formConfig={config}
            defaultValue={instanceToPlain(defaultValue)}
            onClose={handleOnClose}
            onSubmit={handleOnSubmit}
        >
            {({ formConfig, methods, defaultValue, mode, activeStep }) => (
                <>
                    <MainCard>{defaultValue?.original_message}</MainCard>
                    <FormStepper
                        forms={formConfig}
                        mode={mode}
                        methods={methods}
                        status={status}
                        defaultValue={defaultValue}
                        activeStep={activeStep}
                    />
                </>
            )}
        </StandardForm>
    );
};

export default EditDataForm;
